/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { organizationGuestSchema } from "./organizationGuestSchema.ts";

export const orgOrganizationListStatus200Schema = z.array(organizationGuestSchema);

export const orgOrganizationListResponseSchema = orgOrganizationListStatus200Schema;
